import React, {useEffect, useState} from "react";
import {
  Dialog,
  FormControlLabel,
  Grid,
  ListItemText,
  MenuItem,
  Paper, Radio, RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {Box} from "@mui/system";
import TranslationUtil from "@/utils/TranslationUtil";
import {CancelButton, SavingButton} from "@/components/data-grid/CustomButton";
import {useTranslation} from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import NGInputLabel from "@/components/ngteco-form/NGInputLabel";
import {Controller, useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {object, TypeOf, z} from "zod";
import {useSnackbar} from "notistack";
import CompanyService from "@/services/auth/CompanyService";
import i18n from "@/config/i18n";


type DateFormatItemProps = {
  hidePopup?: () => Promise<void>;
};

const DateFormat: React.FC<DateFormatItemProps> = (props) => {
  const {t} = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const {enqueueSnackbar} = useSnackbar();
  const [option, setOption] = React.useState('clocking');

  useEffect(() => {
    if (open) {
      CompanyService.dateFormat({method: 'get'}).then((res) => {
        setOption(res.data?.date_format)
      })
    }
  }, [open])

  const onSubmit = async (data: any) => {
    setLoading(true)
    await CompanyService.dateFormat({method: 'post', date_format: data}).then((res) => {
      enqueueSnackbar(t("common.success"), {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        }
      });
    })
    setLoading(false);
    setOpen(false)
    window.location.reload()
  };
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectOption = (event.target as HTMLInputElement).value
    setOption(selectOption);
  }

  return (
    <Box>
      <MenuItem
        onClick={async () => {
          await props.hidePopup?.();
          setOpen(true);
        }}
      >
        <ListItemText>{t("common.Date Format")}</ListItemText>
      </MenuItem>
      {open && <Dialog
        open={open}
        PaperProps={{
          style: {
            // width: '1200px',
            maxWidth: '400px',
            height: '330px',
          }
        }}
      >
        <DialogTitle>
          {t("common.Select Date Format")}
        </DialogTitle>
        <Grid
          container={true}
          rowSpacing={1}
          columnSpacing={6}
          component={"form"}
          sx={{padding: "0 24px"}}
        >
          <Grid item xs={12} sx={{p: "0 16px"}}>
            <Grid sx={{display: "flex", gap: "24px"}}>
              <Grid container={true} columnSpacing={2} component={"form"}>
                <RadioGroup
                  row={false}
                  name={"option"}
                  value={option}
                  sx={{marginLeft: "20px"}}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: "14px",
                      },
                    }}
                    value={"MM/dd/yyyy"}
                    control={<Radio/>}
                    label={"MM/DD/YYYY"}
                  />
                  <Typography variant="body2" color="text.secondary" sx={{ml: 3.7, mt: 0.5, marginTop: "-10px"}}>
                    {t("common.Standard US Format(e.g. 08/20/2025)")}
                  </Typography>

                  <FormControlLabel
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: "14px",
                      },
                    }}
                    value={"dd/MM/yyyy"}
                    control={<Radio/>}
                    label={"DD/MM/YYYY"}
                  />
                  <Typography variant="body2" color="text.secondary" sx={{ml: 3.7, mt: 0.5, marginTop: "-10px"}}>
                    {t("common.European Format(e.g. 20/08/2025)")}
                  </Typography>
                  <FormControlLabel
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: "14px",
                      }
                    }}
                    value={"yyyy-MM-dd"}
                    control={<Radio/>}
                    label={"YYYY-MM-DD"}
                  />
                  <Typography variant="body2" color="text.secondary" sx={{ml: 3.7, mt: 0.5, marginTop: "-10px", marginBottom: "10px"}}>
                    {t("common.ISO Format(e.g. 2025-08-20)")}
                  </Typography>
                </RadioGroup>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          sx={{
            borderTop: "1px solid #F2F5F8",
            height: "auto",
            minHeight: "60px",
            width: "100%",
            padding: "8px 24px",
            boxSizing: "border-box",
          }}
        >
          <Grid style={{
            marginRight: "10px",
            display: "flex",
            gap: "16px",
            justifyContent: "flex-end"
          }}>
            <CancelButton
              sx={{width: "160px", textTransform: "none"}}
              onClick={() => {
                setOpen(false);
                setLoading(false);
              }}
            />
            <SavingButton
              loading={isLoading}
              children={t("common.save")}
              sx={{width: "160px", textTransform: "none"}}
              onClick={async () => {
                await onSubmit(option);
              }}
            />
          </Grid>
        </Grid>
      </Dialog>}
    </Box>
  );
};
export default DateFormat;
